import {Component, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {FormArray, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {FundService, UpdateFundBudgetYearMode} from "../../../fund-service.service";

export interface BudgetRevenueTable {
  year: number,
  budget_amt: number
}

@Component({
    selector: 'fund-budgeted-revenue',
    templateUrl: './fund-budgeted-revenue.component.html',
    styleUrls: ['./fund-budgeted-revenue.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})


export class FundBudgetedRevenueComponent {
  @Input() budgetDetails: any[]
  @Input() permissions:any;
  @ViewChild(MatSort) sort: MatSort
  public revenueColumns:string[] = ['syndications_budget_year', 'budget_amt']
  public editColumns:string[] = ['syndications_budget_year', 'budget_amt', 'delete']
  public isExpanded:boolean = true;
  public editMode:boolean = false;
  @Output('save') saveForm: EventEmitter<any> = new EventEmitter<any>()
  public budgetArr:FormArray = new FormArray<any>([])
  public budgetForm: FormGroup;
  public dataSource: MatTableDataSource<any>

  constructor(private fb: FormBuilder, private fundService: FundService) {
  }



  public getDataSource(){
    let source = new MatTableDataSource<BudgetRevenueTable>(this.budgetDetails)
    source.sort = this.sort;
    return source
  }

  public toggleEdit(){
    this.editMode = !this.editMode
    if(this.editMode){
      this._setEditValues()
    }
  }

  public save(event:any){
    this.saveForm.emit(event.value)
  }

  public addRow(){
    let newForm = new FormGroup({
      id: new FormControl(null),
      budget_amt: new FormControl(null),
      syndications_budget_year: new FormControl(null)
    })
    this.budgetArr.push(newForm)
    this.dataSource.data = this.budgetArr.controls;
  }

  public deleteRow(row:any){
    let rowId = row.value.id;
    if(rowId===null){
      for(let i = this.budgetArr.controls.length - 1; i >= 0; i--){
        if(this.budgetArr.controls[i].value.id===null){
          this.budgetArr.controls.pop()
          this.dataSource.data = this.budgetArr.controls;
        }
      }
      return;
    } else {
      this.fundService.removeRevenueYearRow(rowId, (response:any) => {
        this.fundService.updateBudgetYearTable(UpdateFundBudgetYearMode.REMOVE, response.data.deleteSyndicationsDetail)
        if(response.data){
          this.dataSource.data = this.budgetArr.controls.filter((control:any) => control.value.id !== response.data?.deleteSyndicationsDetail.id)
        }
      })

    }
  }

  private _setEditValues(){
    if(this.dataSource) return;
    for(let i = 0; i < this.budgetDetails.length; i++){
      const form = new FormGroup({
        id: new FormControl(this.budgetDetails[i].id),
        budget_amt: new FormControl(this.budgetDetails[i].budget_amt),
        syndications_budget_year: new FormControl(this.budgetDetails[i].syndications_budget_year)
      })
      this.budgetArr.push(form)
    }
    this.dataSource = new MatTableDataSource(this.budgetArr.controls)
    this.budgetForm = this.fb.group({
      details: this.budgetArr
    })
  }

}
